/*
 ###############
 ## PreLoader ##
 ###############
 Show a load view when the page is loading.

 * OPTIONS
 * EXAMPLE
 */
require('../../styles/blocks/_preloader.scss');
const React = require('react');
const { connect } = require('react-redux');

class PreLoaderComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            signButton: 'start',
            textInButton: '',
            fadeClass: '',
            status: false,
        };

        this.rotateMessages = this.rotateMessages.bind(this);
        this.runLoadingText = this.runLoadingText.bind(this);
    }

    componentDidUpdate() {
        const { preLoader } = this.props;
        const loadingLabels = preLoader.get('informationArray').toJS();

        if (!this.state.status && loadingLabels.length > 0) {
            this.runLoadingText(loadingLabels);
        }
    }

    componentWillUnmount() {
        clearInterval(this.rotateMessages);
    }

    runLoadingText(loadingLabels) {
        this.setState({
            signButton: 'loading',
            status: true,
        });

        if (loadingLabels.length) {
            this.setState({
                textInButton: loadingLabels[0],
                fadeClass: 'fade-out',
            });
            this.rotateMessages(loadingLabels);
        }
    }

    rotateMessages(array) {
        let i = 1;
        setInterval(() => {
            if (i < array.length) {
                this.setState({
                    textInButton: array[i],
                    fadeClass: '',
                });
                this.setState({
                    fadeClass: 'fade-out',
                });
                i++;
            } else {
                i = 0;
            }
        }, 3500);
    }

    render() {
        const { show, preLoader } = this.props;
        const showSpinner = preLoader.get('showSpinner');
        const showSpinner2 = preLoader.get('showSpinner2');
        const informationText = preLoader.get('informationText');
        const loadingLabels = preLoader.get('informationArray').toJS();
        let startText;

        if (loadingLabels.length > 0) {
            switch (this.state.signButton) {
                case 'start':
                    startText = loadingLabels[0];
                    break;
                case 'loading':
                    startText = this.state.textInButton;
                    break;
                default:
                    startText = loadingLabels[0];
            }
        } else {
            startText = informationText;
        }

        return (
            <div
                className="spinner-wrapper"
                aria-label="spinner"
                style={{ display: showSpinner || showSpinner2 || show ? 'block' : 'none' }}
            >
                <div className="preloader-wrapper-content">
                    <div className="preloader-wrapper active">
                        <div className="spinner-layer spinner-blue-only">
                            <div className="circle-clipper left">
                                <div className="circle"></div>
                            </div>
                            <div className="gap-patch">
                                <div className="circle"></div>
                            </div>
                            <div className="circle-clipper right">
                                <div className="circle"></div>
                            </div>
                        </div>
                    </div>
                    <p className={this.state.fadeClass}>{startText}</p>
                </div>
            </div>
        );
    }
}

export const PreLoader = connect(
    state => ({
        preLoader: state.preLoader,
    }),
    null
)(PreLoaderComponent);
